import React, {useMemo,useState} from "react";

// Custom methods
import { isFunction } from "../../../../../../Libs/CustomMethods/customMethods";

//Redux
import { useSelector, useDispatch } from "react-redux";

// Theme style
import "./lightTheme.scss";

// actions
import { favoriteScript } from "../../../../../../store/favoriteScripts/actions";


const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const FavoriteScript = ({
  msgId,
  enableClick,
  favoritos,
  order,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  let remove = false;

   remove = useMemo(()=>{
    if(favoritos?.length >= 0 && favoritos !== undefined){

      return favoritos?.includes(msgId);
    }else{
      return false;
    }
  },[favoritos,msgId])

  importDarkMode(mainTheme);
  const dispatch = useDispatch();
  const [idClicked, setIdClicked] = useState("");

  const {status} = useSelector(
    (state) => state.FavoriteScripts
  );
  const handleCustomClass = useMemo(() => {    
      if (status?.loading) {
        if (status?.scriptId === idClicked) {
          return "pulsing";
        } else {
          return "blocked";
        }
      }
  },[status,idClicked]);
  
  const starIcon = {
    unchecked: "far fa-star",
    checked: "fas fa-star checked",
  };
  const handleFavoriteScript = (scriptId) => {
      setIdClicked(scriptId);
      dispatch(favoriteScript(scriptId,remove));
    
  };

  return (
    <>
      <div className={`d-flex align-items-center FavoriteScript ${order}`}>
        <i
          onClick={()=>{handleFavoriteScript(msgId)}}
          className={`${remove ? starIcon.checked : starIcon.unchecked} ${
            enableClick ? "starEnabled" : ""
          } ${handleCustomClass} p-1`}
        ></i>
      </div>
    </>
  );
};
export default React.memo(FavoriteScript);
